<ng-container *ngIf="partner">
    <div class="search-card-mobile biz-{{partner.business.uuid}}">
      <div class="mobile-card-header">
        <div class="img-area">
          <div class="img-holder" (click)="navigateToPractitionerPageUrl(partner)">
            <img
              class="img-place"
              *ngIf="partner.logo_image || partner.image_1 || partner.image_2"
              [src]="partner.logo_image || partner.image_1 || partner.image_2"
              alt=""
            />
            <p class="img-place" *ngIf="!(partner.logo_image || partner.image_1 || partner.image_2)">
              {{partner.name | slice : 0 : 2}}
            </p>
            <div class="serv-available" [ngClass]="{'multi': partner.online_enabled && partner.mobile_enabled}" *ngIf="partner.online_enabled || partner.mobile_enabled">
              <button class="profile-icon" *ngIf="partner.online_enabled">
                <img src="assets/images/tele.svg" alt="Telehealth" />
              </button>
              <button class="profile-icon" *ngIf="partner.mobile_enabled">
                <img src="assets/images/mobile.svg" alt="Mobile" />
              </button>
            </div>
          </div>
        </div>
        <div class="mobile-header-details">
          <!-- <div class="badges">
            <p class="recommended" *ngIf="partner?.premium">HIGHLY RECOMMENDED</p>
            <p class="sponsored" *ngIf="partner?.business?.sponsership_active">SPONSORED</p>
          </div> -->
          <h3 class="prac-name" (click)="navigateToPractitionerPageUrl(partner)">{{ getDisplayName(partner) }}</h3>
          <p class="desg" *ngIf="partner.profession_title">{{partner.profession_title}}</p>
        </div>
      </div>
      <div class="mobile-elements-line" >
        <div class="mobile-info-row" *ngIf="(roundedRatingScore || 0) > 0 || (practitioner_rating?.count || 0) > 0">
          <img src="../../../../../assets/icons/rating.svg" alt="Rating">
          <p class="rating">
            <span *ngIf="roundedRatingScore as score">{{ score | number:'1.1-1' }}</span>
            <span *ngIf="(practitioner_rating?.count || 0) > 0">{{practitioner_rating?.count}} reviews</span>
          </p>
        </div>
        <div class="mobile-info-row" *ngIf="getLocation() && bookingType !== 'Online'">
          <img src="../../../../../assets/icons/pin.svg" alt="Rating">
          <p class="rating">
            <span>{{(partner?.business?.business_location?.distance || 0) | number : '1.0-1'}}km away</span>
            <span class="address">{{getLocation()}}</span>
          </p>
        </div>
        <div class="mobile-info-row" *ngIf="partner.online_enabled || partner.mobile_enabled">
          <ng-container *ngIf="partner.online_enabled">
            <img src="../../../../../assets/images/search/telehealth.svg" alt="Telehealth">
            <span class="service-pill" > Telehealth available</span>
          </ng-container>
          <ng-container  *ngIf="partner.mobile_enabled">
            <img src="assets/images/mobile.svg" alt="Mobile">
            <span class="service-pill">Mobile available</span>
          </ng-container>
        </div>
        <div class="mobile-info-row" *ngIf="partner?.year_of_experience">
          <img src="../../../../../assets/images/search/exp.svg" alt="Rating">
          <span class="rating">{{ partner?.year_of_experience | number:'1.0-0' }}+ years of experience</span>
        </div>
      </div>
      <!-- <p class="location mobile-location">
        <span>
          <a class="biz" [routerLink]="getProviderPageUrl()">{{partner.business.name}}</a>
          <span class="distance"> &bull; {{partner?.business?.business_location?.distance | number : '1.0-1'}} km away</span>
        </span>
        <span class="address">{{getLocation()}}</span>
      </p> -->
      <p class="profile mobile-profile" *ngIf="partner?.profile">
        {{getProfileText()}}
        <span class="read-more" *ngIf="this.partner.profile && this.partner.profile.length > this.profileLimit" (click)="readMore = !readMore">{{readMore ? 'read less' :'read more'}}</span>
      </p>
      <div class="focus-section" *ngIf="focusAreas.length">
        <p class="section-title"><img src="../../../../../assets/images/search/areas.svg" alt="">Areas of focus</p>
        <div class="specializations-list">
          <div class="focus-tags">
            <span class="focus-chip" *ngFor="let specialization of focusAreas | slice : 0 : mobileFocusVisible">
              {{replaceSplCharecters(specialization)}}
            </span>
          </div>
          <button class="focus-more-btn" type="button" *ngIf="getMobileFocusRemaining() > 0" (click)="showMoreFocusMobile()">
            +{{getMobileFocusRemaining()}} more
          </button>
        </div>
      </div>
      <div class="availability-card">
        <!-- <p class="availability-title">Next availability</p> -->
        <div class="next-avail" *ngIf="loading">
          <p class="text">Fetching Slots...</p>
        </div>
        <!-- <div class="next-avail" *ngIf="!loading">
          <p class="text" [innerHTML]="fetchNextAvailableDate()"></p>
        </div> -->
        <div class="mobile-timings" *ngIf="timeSlots$ | async as weeklySlots">
          <ng-container *ngIf="weeklySlots.length; else mobileNoSlots">
            <button
              class="slot-day-card"
              type="button"
              *ngFor="let day of weeklySlots; trackBy: trackDay"
              [ngClass]="{ available: day.totalSlots > 0, unavailable: !day.totalSlots }"
              (click)="selectDay(day)"
              [disabled]="!day.totalSlots"
            >
              <span class="slot-day">{{day.label}}</span>
              <span class="slot-date">{{day.displayDate}}</span>
              <span class="slot-count">{{day.appointmentsText}}</span>
            </button>
            <button class="slot-day-card more-slots" type="button" (click)="showMoreSlots(weeklySlots[weeklySlots.length - 1]?.date)">
              <span class="slot-day">View</span>
              <span class="slot-date">next 7 days</span>
              <span class="slot-count" *ngIf="loadingMoreSlots">Loading...</span>
              <span class="slot-count" *ngIf="!loadingMoreSlots">Show slots</span>
            </button>
          </ng-container>
        </div>
        <div class="selected-day-times" *ngIf="selectedDay && selectedDayParts?.length">
          <p class="selected-day-title">{{selectedDay.label}} {{selectedDay.displayDate}}</p>
          <div class="todays-times">
            <div class="time-grp">
              <div class="date-group">
                <button
                  class="time {{slot.key}}"
                  type="button"
                  *ngFor="let slot of selectedDayFlatSlots; trackBy: trackSlot"
                  (click)="selectTime(slot.time, selectedDay.date)"
                >
                  <img [src]="'../../../../../assets/images/businessProfile/' + slot.key + '-1.svg'" alt="">
                  {{slot.time}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="mobile-book-btn" (click)="selectTime('')">Book now</button>
      <!-- <button class="arrow-btn mobile-fav" [ngClass]="{ 'orange': !partner?.details?.data?.favorite, 'green': partner?.details?.data?.favorite }" (click)="partner?.details?.data?.favorite ? '' : (hasLoggedIn() ? saveItemToLists() : loginPage())">
        <img [src]="partner?.details?.data?.favorite ? 'assets/images/menu/heart-filled.svg' : 'assets/images/menu/heart.svg'" alt="">
        <span class="title-hover" *ngIf="!partner?.details?.data?.favorite && !hasLoggedIn()">Login to save into your lists</span>
      </button> -->
    </div>
    <ng-template #mobileNoSlots>
      <p class="no-slots" *ngIf="!loading">No times available this week</p>
    </ng-template>
</ng-container>
